__turbopack_context__.v({
  "container": "ToggleButtonRow-module__w14B0W__container",
  "input": "ToggleButtonRow-module__w14B0W__input",
  "item": "ToggleButtonRow-module__w14B0W__item",
  "leftGradient": "ToggleButtonRow-module__w14B0W__leftGradient",
  "rightGradient": "ToggleButtonRow-module__w14B0W__rightGradient",
  "scrollContainer": "ToggleButtonRow-module__w14B0W__scrollContainer",
  "scrollGradientContainer": "ToggleButtonRow-module__w14B0W__scrollGradientContainer",
  "specialItem": "ToggleButtonRow-module__w14B0W__specialItem",
  "withDesktopColumn": "ToggleButtonRow-module__w14B0W__withDesktopColumn",
});
